import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/hsm-offline/HeroBanner";
import OnCampusTraining from "../components/hsm-offline/OnCampusTraining";
import WhyChooseUs from "../components/hsm-offline/WhyChooseUs";
import WhyChooseHsm from "../components/hsm-offline/WhyChooseHsm";
import CourseOffering from "../components/hsm-offline/CourseOffering";
import LatestBlog from "../components/LatestBlog";
import Contact from "../components/Contact";
import InstaConnect from "../components/InstaConnect";
import MapLocation from "../components/MapLocation";


export default function HsmOffline() {
    return (
        <>
            <Header />

            <HeroBanner />

            <OnCampusTraining />

            <WhyChooseUs />

            <WhyChooseHsm />

            <CourseOffering />

            <MapLocation />

            <InstaConnect />

            <LatestBlog />

            <Contact />

            <Footer />
        </>
    );
}